/*eslint-disable */

import axios from 'axios';
import toast from '@/services/toast';

export default {
  name: 'signle-patient-data-use',
  components: {},
  props: ['selectedModelD'],
  data() {
    return {
      useModelFirstStep: true,
      useModelSecondStep: false,
      submitted: false,
      patient_name:'',
      predictionFilesDescribe:[],
      predictionAlertState:false,
      describeListNext:null,
      modelOutputData:null,
      modelTrainedLoader:false,
      readOnlyPredictionField:false
    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    newPredictionForModelMethod(){
      this.modelOutputData = null
      this.patient_name = ''
      this.useModelFirstStep = true
      this.useModelSecondStep = false
      this.readOnlyPredictionField = false
    },
    stepFirstUseFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          setTimeout(()=>{
            this.$store.dispatch('getAttrOfTrainedForUseModelsFun',{id:this.selectedModelD.id}).then((res)=>{
              this.predictionFilesDescribe = res.data.data.results
              this.describeListNext = res.data.data.next
              this.useModelFirstStep = false
              this.useModelSecondStep = true
              this.submitted =  false
            })},1)
          this.submitted = false
          return;
        }
      })
    },
    nextDescribeListMethod(url){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          axios.get(url).then((response) => {
              this.describeListNext = response.data.data.next
              this.predictionFilesDescribe = [].concat(response.data.data.results,this.predictionFilesDescribe);
              this.submitted = false
            });
          return;
        }
      })
    },
    predictionAllFieldCheckingFun(){ 
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.predictionAlertState = true
        }
      })
    },
    stepSecondUseFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          this.modelTrainedLoader = true
          let data = {
            input_list : this.predictionFilesDescribe,
            model : this.selectedModelD.id,
            run : true,
            patient_name:this.patient_name
          } 
          if(this.selectedModelD.id == process.env.VUE_APP_PUBLIC_AI_MODEL_ID){
            this.$store.dispatch('postConstantAIModelAction', data)
              .then((res) => {  
                this.modelOutputData = res.data.data.results
                toast.success(res.data.msg || "Request processed successfully.");
                this.modelTrainedLoader = false
                this.readOnlyPredictionField = true
                this.submitted =  false
              }).catch((err) => {
                this.modelTrainedLoader = false
                this.submitted =  false
                toast.error(err.data.user_msg || err.data.msg);
              })
            }else{
              this.$store.dispatch('modelsUsingForAiDashFun', data)
                .then((res) => {  
                  this.modelOutputData = res.data.data
                  toast.success(res.data.msg || "Request processed successfully.");
                  this.modelTrainedLoader = false
                  this.readOnlyPredictionField = true
                  this.submitted =  false
                }).catch((err) => {
                  this.modelTrainedLoader = false
                  this.submitted =  false
                  toast.error(err.data.user_msg || err.data.msg);
                })
            }
            return;
        }
      })
    },
    draftUsingCurrentModelsMethod(){
      let data = {
        input_list : this.predictionFilesDescribe,
        model : this.selectedModelD.id,
        run : false,
        patient_name:this.patient_name
      } 
      this.$store.dispatch('modelsUsingForAiDashFun', data)
    },
    validArrCheckOfValueMethod(val){
      return Array.isArray(val)
    }
  }
}